import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

/**
 * Interceptor de autenticación funcional para Angular 17+
 * Maneja automáticamente la adición del token de autorización y los errores 401
 */
export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);

  // Obtener token del localStorage
  const token = localStorage.getItem('access_token');

  // Si hay token, añadirlo a los headers
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // Continuar con la petición
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si el error es 401 (No autorizado)
      if (error.status === 401) {
        handleAuthError(router);
      }

      return throwError(() => error);
    })
  );
};

/**
 * Maneja el error de autenticación, limpiando el almacenamiento y redirigiendo al login
 */
function handleAuthError(router: Router): void {
  const auth = inject(AuthService);

  // Limpiar tokens y storage
  auth.signOut();
  localStorage.removeItem('access_token');
  localStorage.removeItem('currentUser');

  // Redirigir al login con mensaje
  router.navigate(['/login'], {
    queryParams: {
      expired: true,
      message: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    },
  });
}
